import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import "./ProductFaq.css";

// The FAQs of ONE product, as an accordion plus Google FAQ structured data.
// Renders nothing for a product that has no FAQs.
export default function ProductFaq({ faqs, productName }) {
  const [open, setOpen] = useState(null);

  const items = (Array.isArray(faqs) ? faqs : []).filter((f) => f && f.question && f.answer);
  if (items.length === 0) return null;

  // "<" is escaped so an answer can never close the script tag early.
  const structuredData = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  }).replace(/</g, "\\u003c");

  return (
    <section className="pfaq" aria-labelledby="pfaq-title">
      <Helmet>
        <script type="application/ld+json">{structuredData}</script>
      </Helmet>
      <div className="pfaq-container">
        <h2 id="pfaq-title" className="pfaq-title">
          Frequently Asked Questions
          {productName && <small>About {productName}</small>}
        </h2>

        {items.map((item, index) => {
          const isOpen = open === index;
          return (
            <div key={item.id || index} className={`pfaq-card ${isOpen ? "is-open" : ""}`}>
              <h3 className="pfaq-q">
                <button
                  type="button"
                  className="pfaq-btn"
                  aria-expanded={isOpen}
                  aria-controls={`pfaq-answer-${index}`}
                  onClick={() => setOpen(isOpen ? null : index)}
                >
                  <span>{item.question}</span>
                  <span className="pfaq-icon" aria-hidden="true">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>
              </h3>
              <div id={`pfaq-answer-${index}`} className="pfaq-answer" role="region" hidden={!isOpen}>
                <p>{item.answer}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
